<template>
  <div v-show="show">
    <div class="actModules">
      <h3 class="actModules_title">{{tiTle}}</h3>
      <p class="actModules_descripe">{{rules}}</p>
      <p class="actModules_btnDescript">{{integral + value}}</p>
      <ul class="actInvite_boxWrap">
        <li
          class="actInvite_boxList"
          v-for="(item, index) in giftList"
          :key="index"
          v-if="item.h5Action.value"
        >
          <div class="main">
            <div>{{item.name}}</div>
            <img :src="item.img.value" />
            <div>{{item.text}}</div>
            <div class="actInvite_boxBtnWrap">
              <a
                href="javascript:;"
                @click="doAction(item.h5Action, index)"
                :class="`actCharge_boxBtn ${h5Geted[index]?'disabled':''}`"
                class="actCharge_boxBtn"
              >立即领取</a
              >
            </div>
            <div>{{item.remarks}}</div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import '../../assets/css/reset.css';
import bus from '../../../bus';
import action from '../components/index';
export default {
	name: 'h5-verticalplate',
	actConfig: {
		labels: {
			// 字段名称，用于显示在配置系统上
			tiTle: '头部文案',
			rules: '活动规则',
			integral: '积分名称描述',
			h5Action: 'H5动作',
			giftList: '礼包信息',
			integralquery: '积分查询',
			name: '礼包名称',
			text: '可获积分或所需积分',
			remarks: '领取或兑换限制',
			img: '礼包图片',
			showtype: '机型展示(1安卓,0 IOS)',
			popup: '是否弹窗提示(1是,不是为空)',
			popuptext: '弹窗提示语'
		}
	},
	props: {
		tiTle: {
			type: String,
			default: '模块标题'
		},
		rules: {
			type: String,
			default: '活动规则：规则文案'
		},
		integral: {
			type: String,
			default: '我的积分：'
		},
		integralquery: {
			type: Array,
			default: () =>
				[
					{
						h5Action: {
							class: 'action',
							title: '查询积分',
							type: 'no',
							value: ''
						}
					}
				]
		},
		showtype: {
			type: String,
			default: ''
		},
		popup: {
			type: String,
			default: ''
		},
		popuptext: {
			type: String,
			default: ''
		},
		giftList: {
			type: Array,
			default: () =>
				Array(20).fill({
					name: '礼包名称',
					text: '可获积分或所需积分',
					remarks: '每日限制24',
					img: {
						class: 'image',
						value: ''
					},
					h5Action: {
						class: 'action',
						type: 'no',
						value: '',
						ruleId: ''
					},
				})
		},
	},
	data () {
		return {
			h5Geted: [false],
			show: true,
			value: 0
		};
	},
	mounted () {
		if (this.$actMode !== 'production') {
			return;
		}
		bus.$on('giftReceivedStatus', isGetedh5 => {
			this.queryshow();
			if (isGetedh5) {
				let h5Geted = action.query(isGetedh5, this.giftList);
				this.h5Geted = h5Geted;
			}
		});
		bus.$on('showtype', val => {
			this.show = val === this.showtype;
		});
	},
	methods: {
		async doAction (val, index) {
			let status = '';
			if (this.popup) {
				status = await action.receive(val, this.tiTle, this.popuptext);
			} else {
				const {type, value} = val;
				status = await action.gift(type, value, this.tiTle);
			}
			this.$set(this.h5Geted, index, status);
		},
		async queryshow () {
			const [{h5Action: { type, value }} = {}] = this.integralquery;
			const {sOutValue1} = await action.queryshow(type, value);
			this.value = sOutValue1;
		}
	}
};
</script>

<style scoped lang="scss">
  @import "../../assets/scss/common";
  .actModules_btnDescript {
    font-size: 0.24rem;
  }
  .actInvite_boxWrap {
    width: 7.3rem;
    margin: 0.6rem auto 0;
    display: flex;
    flex-wrap: wrap
  }
  .actInvite_boxList {
    width: 2rem;
    height: 3.8rem;
    margin: auto .2rem;
    img{
      width: 1.3rem;
      height: 1.3rem;
      margin: .2rem auto;
    }
    .main{
      width: 2rem;
      font-size: .2rem;
      text-align: center;
    }
    .actInvite_boxBtnWrap {
      height: .6rem;
      width: 2rem;
      margin: .1rem auto;
      font-size: .2rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/actModules/h5/templates/receive-v/h5-verticalplate.vue